import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/public/index'
/*防止连续点击 */
import directives from '@/utils/point'
Vue.use(directives)
import jquery from "jquery";
Vue.prototype.$ = jquery;

Vue.config.productionTip = false
// 校验文件类型
Vue.prototype.fileExtension = function (type: any) {
  return type.substring(type.lastIndexOf('.') + 1)
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
